import React from 'react';

import classnames from 'classnames/bind';
import styles from './ClubMembershipStaticContent.module.scss';
import { Divider, Skeleton } from '@mui/material';

const CN = 'club-membership-static-content';
const topBannerContainerClassName = `${CN}__top-banner-container`;
const promoPointsContainerClassName = `${CN}__promo-points-container`;
const promoPointClassName = `${promoPointsContainerClassName}__promo-point`;
const titleContainerClassName = `${CN}__title-container`;
const rightAlignedImageClassName = 'right-aligned-image';
const promoTextContainerClassName = 'promo-point-text';
const promoImageClassName = 'promo-point-image';
const faqContainerClassName = `${CN}__faq-container`;
const faqTextClassName = `${faqContainerClassName}__text`;

const cx = classnames.bind(styles);

export const ClubMembershipStaticContentSkeleton: React.FC = () => (
  <div className={ cx(CN) }>
    <Skeleton height={ 300 } className={ cx(topBannerContainerClassName) } variant='rectangular'/>
    <div className={ cx(titleContainerClassName) }>
      <Skeleton width={ 200 } variant='text' />
      <Skeleton width={ 100 } variant='text' />
    </div>
    <div className={ cx(promoPointClassName) }>
      <Skeleton className={ cx(promoImageClassName) } height={ 400 } width='30%'/>
      <div className={ cx(promoTextContainerClassName) }>
        <Skeleton variant='text' />
        <Skeleton variant='text' />
      </div>
    </div>
    <div className={ cx(promoPointClassName, rightAlignedImageClassName) }>
      <Skeleton className={ cx(promoImageClassName) } height={ 400 } width='30%' />
      <div className={ cx(promoTextContainerClassName) }>
        <Skeleton variant='text' />
        <Skeleton variant='text' />
      </div>
    </div>
    <div className={ cx(promoPointClassName) }>
      <Skeleton className={ cx(promoImageClassName) } height={ 400 } width='30%' />
      <div className={ cx(promoTextContainerClassName) }>
        <Skeleton variant='text' />
        <Skeleton variant='text' />
      </div>
    </div>
    <div className={ cx(faqContainerClassName) }>
      <Skeleton width={ 100 } variant='text' className={ cx(faqTextClassName) }/>
      <Skeleton height={ 50 } variant='rectangular'/>
      <Divider />
      <Skeleton height={ 50 } variant='rectangular'/>
      <Divider />
      <Skeleton height={ 50 } variant='rectangular'/>
    </div>
  </div>
);
